// import { IndexerSource } from '@prisma/client'

type Props = {
  source: any
  onSubmit?: (sourceUpdated: any) => void
}

export const FormSetup: React.FC<Props> = ({ source, onSubmit }) => {
  return <>TODO</>
  // const { data: account } = Api.providerAccount.findUnique.useQuery({
  //   where: { id: source.providerAccountId },
  //   include: { provider: true },
  // })
  // const { provider } = account || {}
  // const { providerClient } = useProvider({ provider })

  // const [stepIndex, setStepIndex] = useState(1)

  // const [sourceUpdated, setSourceUpdated] = useState(source)

  // const handleNext = (sourceUpdated: IndexerSource) => {
  //   setSourceUpdated(sourceUpdated)
  //   setStepIndex(index => (index += 1))
  // }

  // const handleSubmit = (sourceUpdated: IndexerSource) => {
  //   onSubmit?.(sourceUpdated)
  // }

  // const handleBack = () => {
  //   setStepIndex(index => (index -= 1))
  // }

  // if (!provider) {
  //   return (
  //     <Flex align="center" justify="center" className="w-full">
  //       <Typography.Text type="secondary">
  //         No configuration available for {provider?.name}
  //       </Typography.Text>
  //     </Flex>
  //   )
  // }

  // return (
  //   <Flex vertical className="w-full p-4">
  //     <providerClient.FormSetupSteps
  //       source={sourceUpdated}
  //       stepIndex={stepIndex}
  //       onNext={handleNext}
  //       onSubmit={handleSubmit}
  //     />

  //     {stepIndex > 1 && (
  //       <Flex>
  //         <Button icon={<CaretLeftFilled />} type="text" onClick={handleBack}>
  //           Back
  //         </Button>
  //       </Flex>
  //     )}
  //   </Flex>
  // )
}
